export default __webpack_public_path__ + "static/media/3Loop.2b9c4d4b.mp4";